module.exports = __webpack_public_path__ + "img/1F608.93de4d49.svg";